import { UserRole } from '../models/user.model';

/**
 * German display labels for each role. Used by the user-modal dropdown and any
 * role badges so the UI stays in sync with the enum.
 */
export const ROLE_LABELS: Record<UserRole, string> = {
  [UserRole.ADMIN]: 'Administrator',
  [UserRole.FERTIGUNGSMITARBEITER]: 'Fertigungsmitarbeiter',
  [UserRole.BUERO]: 'Büro',
  [UserRole.WARENEINGANG]: 'Wareneingang',
  [UserRole.ENDKONTROLLE]: 'Endkontrolle',
  [UserRole.WARENAUSGANG]: 'Warenausgang',
};

/** Roles that may access the Aufträge (orders) page. */
export const ORDERS_ROLES: UserRole[] = [UserRole.BUERO];

/** Roles that may access the order document (Auftragsbegleitschein) page. */
export const ORDER_DOCUMENT_ROLES: UserRole[] = [
  UserRole.FERTIGUNGSMITARBEITER,
  UserRole.BUERO,
  UserRole.WARENEINGANG,
  UserRole.ENDKONTROLLE,
];

/** Roles that may add, edit and delete Fehlererfassung (false positions) rows. Every role may read them. */
export const FALSE_POSITION_ROLES: UserRole[] = [UserRole.ENDKONTROLLE];

/** Roles that may delete documents on the Dokumente tab. Every role may view and upload them;
 * after the DMS export only ADMIN may still delete a document. */
export const DOCUMENT_DELETE_ROLES: UserRole[] = [UserRole.BUERO, UserRole.WARENEINGANG];

/** Roles that may access the Lieferzettel (delivery-notes) pages. */
export const DELIVERY_NOTE_ROLES: UserRole[] = [UserRole.BUERO, UserRole.ENDKONTROLLE, UserRole.WARENAUSGANG];

/**
 * Returns true if the given role may access a route that permits `allowedRoles`.
 * ADMIN is always allowed.
 */
export function canAccess(role: UserRole | undefined | null, allowedRoles: UserRole[]): boolean {
  if (!role) return false;
  if (role === UserRole.ADMIN) return true;
  return allowedRoles.includes(role);
}

/**
 * The landing route a user should be redirected to after login or when hitting a
 * forbidden route. Administrator → dashboard; other roles → the first page they may access.
 */
export function getLandingRoute(role: UserRole | undefined | null): string {
  if (role === UserRole.ADMIN) return '/dashboard';
  if (role && ORDER_DOCUMENT_ROLES.includes(role)) return '/order-documents';
  if (role && DELIVERY_NOTE_ROLES.includes(role)) return '/delivery-notes';
  return '/login';
}
